import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProductCard } from '../components/ProductCard';
import { FinalOffer } from '../components/FinalOffer';
import { Footer } from '../components/Footer';
const products = [{
  title: 'Vladimir Padrino López',
  image: 'https://cdn.magicpatterns.com/uploads/6hme3h57wjqTdFr7i4ehfu/VLADIMIR_PADRINO_LOPEZ_PORTADA_AUDIBLE.png',
  benefits: ['Trayectoria militar y ascenso político en Venezuela', 'Audiolibro para aprender en cualquier momento', 'Presentación visual con cronología detallada'],
  ctaText: 'Descubre la historia completa'
}, {
  title: 'Cilia Flores',
  image: 'https://cdn.magicpatterns.com/uploads/1tacVEEgxTKKW8gAZzG8xY/C16C6B36-8D2A-4A64-ABC5-5D313E03D6E5.png',
  benefits: ['Carrera política y rol en el gobierno venezolano', 'Audiolibro para escuchar en cualquier lugar', 'Presentación visual para repasar los momentos clave'],
  ctaText: 'Explora su trayectoria política'
}, {
  title: 'Antonio Ledezma',
  image: 'https://cdn.magicpatterns.com/uploads/gGXHr5YCZmVCRG9mCzoNST/ANTONIO_LEDEZMA_PORTADA_AUDIBLE.png',
  benefits: ['Liderazgo opositor y activismo político', 'Audiolibro para aprender de forma práctica', 'Presentación visual con hitos decisivos'],
  ctaText: 'Conoce su historia completa'
}];
export function LandingPage() {
  return <main className="min-h-screen w-full bg-[#0a0a0a]" data-id="element-111">
      <HeroSection data-id="element-112" />

      {/* Divider */}
      <div className="w-full h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" data-id="element-113" />

      {/* Product Sections */}
      {products.map((product, index) => <div key={product.title} data-id="element-114">
          <ProductCard title={product.title} image={product.image} benefits={product.benefits} ctaText={product.ctaText} reversed={index % 2 === 1} index={index} data-id="element-115" />
          {index < products.length - 1 && <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-800 to-transparent" data-id="element-116" />}
        </div>)}

      {/* Final Offer */}
      <FinalOffer data-id="element-117" />

      {/* Footer */}
      <Footer data-id="element-118" />
    </main>;
}